import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import { inboxSearchSchema, OrgInboxPage } from '@/features/conversations';

/** The organisation-wide inbox (D-103 Q19): every store the member can access, one list. */
export const Route = createFileRoute('/_authed/_active/org/inbox')({
  staticData: { crumb: 'common:nav.inbox' },
  validateSearch: inboxSearchSchema,
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'conversations.read');
  },
  component: OrgInboxPage,
});
